module.exports = __webpack_public_path__ + "img/1717490097589-WhatsApp Image 2024-06-04 at 15.17.49.jpeg.618e6014.webp";